module.exports = __webpack_public_path__ + "img/net-cost.99bfb72a.svg";